import Validator from '../../validator';

const NameChangeValidator = new Validator([
  {
    field: 'effDate',
    method: 'isEmpty',
    validWhen: false,
    message: 'Effective Date is required.',
  },
  {
    field: 'currentName',
    method: 'isEmpty',
    validWhen: false,
    message: 'Current Name of Insured is required.',
  },
  {
    field: 'currentEntity',
    method: 'isEmpty',
    validWhen: false,
    message: 'Current Legal Entity of Insured is required.',
  },
  {
    field: 'newName',
    method: 'isEmpty',
    validWhen: false,
    message: 'New Name of Insured is required.',
  },
  {
    field: 'newEntity',
    method: 'isEmpty',
    validWhen: false,
    message: 'New Legal Entity of Insured is required.',
  },
  {
    field: 'file',
    method: 'isEmpty',
    validWhen: false,
    message: 'Revised Bylaws are required to submit a name change request.',
  },
]);

export default NameChangeValidator;
